import React from 'react'
// libs
import styled from 'styled-components'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'

const MenuItem = styled(MenuItemOrigin)`
  && {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

interface Props {
  name: string
  disabled: boolean
  isMobile?: boolean
  handleClick: () => Promise<void>
}

const RiskFunction: React.FC<Props> = ({ name, disabled, isMobile, handleClick }) => {
  const [loading, setLoading] = React.useState(false)

  const onFunctionClick = async () => {
    setLoading(true)

    await handleClick()

    setLoading(false)
  }

  if (isMobile) {
    return (
      <MenuItem disabled={disabled || loading} onClick={onFunctionClick}>
        {name}
      </MenuItem>
    )
  }

  return (
    <Button
      disabled={disabled}
      isLoading={loading}
      onClick={onFunctionClick}
      style={CREATE_BUTTON_STYLE}
      layout={BUTTON_LAYOUTS.PURPLE}>
      {name}
    </Button>
  )
}

export default RiskFunction
